import clsx from 'clsx';
import { SelectCustomizable } from 'ui';
import StatusIcon from 'core/modules/atoms/StatusIcon/StatusIcon';
import PropTypes from 'prop-types';
import React from 'react';
import useInputPointsQualitativeScale from './useInputPointsQualitativeScale';

const InputPointsQualitativeScale = ({
  onChange,
  disabled = false,
  size,
  isScoreReadOnly,
  showDotted = false,
  isLate = false,
  colorsPoints,
  evaluationScale,
  changeError,
  t,
  ...props
}) => {
  const { hasError, onChangeOption, onFocus, onBlur, statusColor, options, selectedOption } = useInputPointsQualitativeScale({
    props,
    onChange,
    colorsPoints,
    changeError,
    evaluationScale,
  });

  return (
    <div className={clsx('input-points', `input-points--status-${statusColor}`, { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <SelectCustomizable
          className="input-points-qualitative__input"
          onFocus={onFocus}
          onBlur={onBlur}
          isDisabled={disabled || isScoreReadOnly}
          value={selectedOption || null}
          options={options}
          onChange={onChangeOption}
          placeholder={disabled || isScoreReadOnly ? '' : t('actions:Select')}
          defaultValue={selectedOption || null}
          // Configuración para asegurar que el menú esté por encima
          menuPortalTarget={document.body}
          menuPosition={'fixed'}
          menuPlacement={'auto'}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999, fontSize: '12px' }),
          }}
        />
        {isLate && (
          <div className="input-points__late">
            <StatusIcon iconName="exclamation-circle" label={t('lesson:Delivered late')} shouldShowTooltip />
          </div>
        )}
      </div>
    </div>
  );
};

InputPointsQualitativeScale.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showDotted: PropTypes.bool,
  isLate: PropTypes.bool,
  colorsPoints: PropTypes.bool,
  evaluationScale: PropTypes.object,
  changeError: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  isScoreReadOnly: PropTypes.bool,
  t: PropTypes.func,
};

export default InputPointsQualitativeScale;
